// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-block {
  margin-bottom: 30px;
  text-align: left;
}

.question-text {
  font-weight: 600;
  margin-bottom: 10px;
  color: #2b6cb0;
}

.question-input {
  margin-bottom: 15px;
}

.question-divider {
  margin-top: 20px;
  margin-bottom: 20px;
  border: none;
  border-top: 1px solid #e2e8f0;
}

.submit-container {
  text-align: center;
  margin-top: 40px;
}

.submit-container button {
  background-color: #2b6cb0;
  color: white;
  border: none;
  padding: 15px 40px;
  font-size: 1rem;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-container button:hover {
  background-color: #2c5282;
}
`, "",{"version":3,"sources":["webpack://./src/pages/QuestionnairePage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".question-block {\n  margin-bottom: 30px;\n  text-align: left;\n}\n\n.question-text {\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #2b6cb0;\n}\n\n.question-input {\n  margin-bottom: 15px;\n}\n\n.question-divider {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: none;\n  border-top: 1px solid #e2e8f0;\n}\n\n.submit-container {\n  text-align: center;\n  margin-top: 40px;\n}\n\n.submit-container button {\n  background-color: #2b6cb0;\n  color: white;\n  border: none;\n  padding: 15px 40px;\n  font-size: 1rem;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.submit-container button:hover {\n  background-color: #2c5282;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
